<template>
  <div class="filter-radio">
    <div class="d-flex mt-2">
      <ErrorButton @click="handleClear" text shrink v-if="isNumber(value)">
        Clear
      </ErrorButton>
    </div>
    <v-text-field v-model="searchText" placeholder="Search" clearable />
    <v-radio-group v-model="value">
      <v-radio
        v-for="(option, index) in filteredOptions"
        :key="index"
        :label="option.text"
        @change="() => saveChanges(option.value)"
      />
    </v-radio-group>
  </div>
</template>

<script>
import ErrorButton from "@/components/common/Button/ErrorButton";
import { isNumber } from "lodash";
import { searchInFilterOptions } from "@/utils/filters";

export default {
  props: {
    selectedValue: [Number, String],
    options: {
      type: Array,
      required: true
    }
  },
  components: { ErrorButton },
  data() {
    return {
      value: this.selectedValue,
      searchText: ""
    };
  },
  computed: {
    filteredOptions() {
      return searchInFilterOptions(this.searchText, this.options);
    }
  },
  methods: {
    saveChanges(value) {
      this.value = value;
      this.$emit("change", value);
    },
    handleClear() {
      this.saveChanges();
    },
    isNumber
  }
};
</script>

<style lang="scss">
.filter-radio {
  div[role="radiogroup"] label {
    margin-left: 10px;
  }
}
</style>
